import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import hu from './hu.json';
import en from './en.json';

const resources: Resource = {
  hu: {
    translation: hu,
  },
  en: {
    translation: en,
  },
};

export const supportedLanguages = Object.keys(resources);

i18n.use(initReactI18next).init(
  {
    resources,
    supportedLngs: supportedLanguages,
    fallbackLng: 'en',
    lng: 'en',
    interpolation: {
      escapeValue: false,
    },
  },
  () => i18n.language,
);
export default i18n;
